import apiClient from '@/lib/apiClient';
import { extractPaginatedData } from '@/shared/utils/queryUtils';
import type {
  AdminFilterPreset,
  AdminFilterResource,
  AdminSearchRequest,
  AdminSearchResult,
  FilterMetadataResponse,
  SaveAdminFilterPresetRequest,
  UpdateAdminFilterPresetRequest,
} from './types';

export async function getAdminFilterMetadata(resource: AdminFilterResource): Promise<FilterMetadataResponse> {
  const res = await apiClient.get(`/admin/${resource}/filter-metadata`);
  return res.data?.data;
}

export async function searchAdminResource<T>(
  resource: AdminFilterResource,
  request: AdminSearchRequest,
): Promise<AdminSearchResult<T>> {
  const res = await apiClient.post(`/admin/${resource}/search`, request);
  return extractPaginatedData<T>(res);
}

export async function listAdminFilterPresets(resource: AdminFilterResource): Promise<AdminFilterPreset[]> {
  const res = await apiClient.get(`/admin/${resource}/filter-presets`);
  return res.data?.data || [];
}

export async function createAdminFilterPreset(
  resource: AdminFilterResource,
  request: SaveAdminFilterPresetRequest,
): Promise<AdminFilterPreset> {
  const res = await apiClient.post(`/admin/${resource}/filter-presets`, request);
  return res.data?.data;
}

export async function updateAdminFilterPreset(
  resource: AdminFilterResource,
  id: number,
  request: UpdateAdminFilterPresetRequest,
): Promise<AdminFilterPreset> {
  const res = await apiClient.patch(`/admin/${resource}/filter-presets/${id}`, request);
  return res.data?.data;
}

export async function setDefaultAdminFilterPreset(
  resource: AdminFilterResource,
  id: number,
): Promise<AdminFilterPreset> {
  const res = await apiClient.post(`/admin/${resource}/filter-presets/${id}/default`);
  return res.data?.data;
}

export async function deleteAdminFilterPreset(resource: AdminFilterResource, id: number): Promise<void> {
  await apiClient.delete(`/admin/${resource}/filter-presets/${id}`);
}
